// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"27b61706","246":"95fbdf96","453":"8e9e3179"}[chunkId] + ".chunk.js";
};